import {Select} from 'antd';
import {useContext, useMemo, useState} from 'react';

import {Locale} from '../../../../../provider/locale/locale';
import {useLocale} from '../../../../../provider/locale/locale-hook';
import {MainFilterContext} from '../../../../../provider/main-filter/main-filter';
import {MainFilterContextType} from '../../../../../provider/main-filter/main-filter-type';
import {useReviewAnalyticsTagSearch} from '../../../../../service/reivew-analysis/review-analytics-tags/review-analytics-tag-hook';
import {debounce} from '../../../../../util/function';
import {reviewAnalysisAutocompleteLimit} from '../drawer-filter/drawer-filter-const';
import {compareSelectOptions, renderSelectOption} from '../drawer-filter/drawer-filter-helper';
import {SelectOptionType} from '../drawer-filter/drawer-filter-type';

type PropsType = {
    value?: Array<string>;
    onChange?: (value: Array<string>) => void;
};

export function TagSelect(props: PropsType): JSX.Element {
    const {value, onChange} = props;

    const {shortLocaleName} = useLocale();

    const {mainFilterKey} = useContext<MainFilterContextType>(MainFilterContext);

    const [q, setQ] = useState<string>('');
    const {result: tagsResult, isInProgress: isTagsInProgress} = useReviewAnalyticsTagSearch(
        {
            count: reviewAnalysisAutocompleteLimit,
            page: 1,
            q,
        },
        mainFilterKey
    );
    const tagOptions: Array<SelectOptionType<string>> = useMemo((): Array<SelectOptionType<string>> => {
        return (tagsResult || [])
            .map<SelectOptionType<string>>(
                (tag: string): SelectOptionType<string> => ({
                    id: tag,
                    name: tag,
                })
            )
            .sort(compareSelectOptions<string>(shortLocaleName));
    }, [tagsResult, shortLocaleName]);

    return (
        <Select<Array<string>>
            disabled={false}
            loading={isTagsInProgress}
            mode="multiple"
            // eslint-disable-next-line no-undefined
            notFoundContent={q === '' ? null : undefined}
            onBlur={() => setQ('')}
            onChange={onChange}
            onSearch={debounce<[string]>(setQ, 300)}
            optionFilterProp="children"
            placeholder={<Locale stringKey="REVIEWS_ANALYSIS__FORM__INPUT__KEYWORDS__PLACEHOLDER" />}
            value={value}
        >
            {tagOptions.map(renderSelectOption)}
        </Select>
    );
}
